export const UpdateIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16998_14392)">
        <g clipPath="url(#clip1_16998_14392)">
          <path
            d="M11.4864 12.9722H15.2017V16.6875M8.51416 7.02778H4.79888V3.3125M15.5123 7.77306C15.0956 6.74184 14.3981 5.84818 13.4989 5.19367C12.5996 4.53915 11.5348 4.15003 10.4255 4.07054C9.31614 3.99104 8.20673 4.22436 7.22338 4.74398C6.24003 5.2636 5.42217 6.04866 4.86278 7.00994M4.48828 12.2269C4.90498 13.258 5.60254 14.1514 6.50169 14.8058C7.40083 15.4602 8.4655 15.8492 9.57471 15.9287C10.6839 16.0082 11.7932 15.775 12.7765 15.2555C13.7597 14.736 14.5775 13.9511 15.137 12.9901"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_16998_14392">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
        <clipPath id="clip1_16998_14392">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  )
}
